import { Box, Typography, TypographyProps } from '@mui/material'

type ListProps = {
  icon?: string
  items: React.ReactNode[]
  variant?: TypographyProps['variant']
} & React.ComponentProps<typeof Box>

const List = ({ items, icon, variant = 'p3', sx, ...otherProps }: ListProps) => (
  <Box
    component="ul"
    sx={{ listStyle: icon ? 'none' : 'disc', ...sx }}
    marginY="8px"
    {...otherProps}
  >
    {items.map((item, i) => (
      <Typography
        sx={
          icon
            ? {
                '&:before': {
                  background: `url(${icon}) center no-repeat`,
                  content: '""',
                  height: '100%',
                  left: '-30px',
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '23px',
                },
                position: 'relative',
              }
            : {}
        }
        key={i}
        component="li"
        variant={variant}
        marginY="8px"
      >
        {item}
      </Typography>
    ))}
  </Box>
)

export default List
